module.exports = __webpack_public_path__ + "img/geography.9281cb65.png";